<template>
  <div>
    <el-upload
      v-if="!disabled"
      action="#"
      :multiple="multiple"
      :limit="multiple ? 20 : 1"
      :file-list="fileList"
      :http-request="upload"
      :on-remove="remove"
      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
    >
      <el-button size="small" type="primary" icon="el-icon-upload2"
        >选择文件</el-button
      >
      <div slot="tip" class="el-upload__tip">支持 PDF、图片和 Word 文件</div>
    </el-upload>
    <div v-else-if="!urls.length" class="empty">暂无文件</div>
    <template v-if="disabled">
      <el-link
        v-for="(url, index) in urls"
        :key="url + index"
        :href="url"
        target="_blank"
        type="primary"
        class="file-link"
        ><i class="el-icon-document" /> 文件 {{ index + 1 }}</el-link
      >
    </template>
  </div>
</template>
<script>
import { uploadEmployerFile } from "@/api/employer-insurance";
export default {
  name: "EmployerFileUpload",
  props: {
    value: { type: [String, Array], default: "" },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    urls() {
      return Array.isArray(this.value)
        ? this.value.filter(Boolean)
        : this.value
        ? [this.value]
        : [];
    },
    fileList() {
      return this.urls.map((url, index) => ({
        name: decodeURIComponent(
          String(url)
            .split("?")[0]
            .split("/")
            .pop() || `文件${index + 1}`
        ),
        url,
        uid: `${url}-${index}`
      }));
    }
  },
  methods: {
    async upload(options) {
      const data = new FormData();
      data.append("fileVal", options.file);
      try {
        const res = await uploadEmployerFile(data);
        const url =
          res &&
          (typeof res.data === "string" ? res.data : res.data && res.data.url);
        if (!url) throw new Error("upload failed");
        this.$emit("input", this.multiple ? [...this.urls, url] : url);
        options.onSuccess(res);
        this.$message.success("上传成功");
      } catch (error) {
        options.onError(error);
        this.$message.error("上传失败");
      }
    },
    remove(file) {
      const urls = this.urls.filter(url => url !== file.url);
      this.$emit("input", this.multiple ? urls : "");
    }
  }
};
</script>
<style lang="less" scoped>
.file-link {
  display: block;
  margin: 4px 0;
}
.empty {
  color: #909399;
}
</style>
